module.exports = __webpack_public_path__ + "img/2024-08-29c_1.38ce800a.jpg";